import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import fp from '../assets/FP.png'

export default function HeroSection() {
  const theme = useTheme();

  return (
    <Box
      id="hero-section"
      component="section"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        pt: { xs: 4, md: 8 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, pt: 0, pb: 0 }}>
        <Stack alignItems="center" textAlign="center">
          <Paper
            elevation={0}
            sx={{
              py: { xs: 2, md: 3 },
              px: { xs: 2, md: 3 },
              backgroundColor: '#1a1f3a',
              border: `1px solid ${theme.palette.primary.dark}`,
              borderRadius: 0.8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              mb: 3,
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontWeight: 900,
                background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.main} 100%)`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                lineHeight: 1.2,
                mb: 2,
              }}
            >
              janironkainen.com
            </Typography>
            <Box
              sx={{
                width: { xs: '150px', sm: '200px', md: '250px' },
                height: { xs: '150px', sm: '200px', md: '250px' },
                borderRadius: '50%',
                border: `3px solid ${theme.palette.primary.main}`,
                overflow: 'hidden',
                mb: 1,
              }}
            >
              <Box
                component="img"
                src={fp}
                alt="Profile"
                loading="eager"
                fetchPriority="high"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Paper>
        </Stack>
      </Container>
    </Box>
  );
}
